'use client'

import React from 'react'
import { Container } from 'react-bootstrap'
import Script from 'next/script'

import bharat_petroleum from '@/assets/icon/bharat-petroleum.webp'
import indian_oil_logo from '@/assets/icon/indian-oil-logo.webp'
import mstc from '@/assets/icon/mstc.webp'

import nhai_logo from '@/assets/icon/nhai-logo.webp'
import pwd_logo from '@/assets/icon/pwd-logo.webp'
import Link from 'next/link'
import tenderbook from '@/assets/home/tenderbook-banner.png'
import Image from 'next/image'
function OfferBanner() {
	const logosWeb = [bharat_petroleum, indian_oil_logo, nhai_logo, pwd_logo, mstc]
	const logosMob = [bharat_petroleum, indian_oil_logo, nhai_logo, pwd_logo]
	return (
		<>
			{/* <div className='offer-banner-container '>
				<div className='offer-banner-inner'>
					<h1>Simplifying Recycling to promote a Sustainable Future and a robust Circular Economy</h1>
					<p className='card-description'>
						Metalbook's vision is to reduce dependency on raw material mining, and contribute in the reduction of global greenhouse gas
						emissions.
					</p>

					<div className='schedule-demo'>
						<Link
							href='https://calendly.com/metalbook/metalbook-live-demo'
							target='_blank'
							className={`btn border ${styles.scheduleDemo}`}
						>
							<p>Schedule a Demo</p>
						</Link>

						<Link className={`btn btn-primary border-0 ${styles.orderNow}`} href='/products'>
							<p>Order Now</p>
						</Link>
					</div>
				</div>
			</div> */}

			<div className='tenderbook-section'>
				<div className='tender-card-container'>
					<div className='tender-card-content'>
						<div className='tender-card-header-group'>
							<header className='tender-card-header'>
								<p className='tender-card-title'>Do you participate in </p>
								<p className='tender-card-title' style={{ fontWeight: 600 }}>
									Goverment Tenders?
								</p>
							</header>
							<p className='tender-card-description'>
								Use Tenderbook to find the right tenders for your business, get assistance with applying for tenders, and never miss
								an opportunity again — powered by Metalbook.
							</p>
						</div>

						<Link href={'https://tenderbook.in'} target='_blank' className='tender-card-cta'>
							Explore Tenderbook
						</Link>

						<div className='logos-desktop'>
							{logosWeb.map((logo, idx) => (
								<div key={idx} className='logo-item'>
									<Image src={logo} alt='logo' className='logo-image' />
								</div>
							))}
						</div>

						<div className='logos-mobile'>
							{logosMob.map((logo, idx) => (
								<div key={idx} className='logo-item'>
									<Image src={logo} alt='logo' className='logo-image' />
								</div>
							))}
						</div>
					</div>

					<div className='tender-card-image-wrapper'>
						<Image src={tenderbook} alt='tenderbook hero' className='tender-card-image' />
					</div>
				</div>
			</div>
		</>
	)
}

export default OfferBanner
